import React from 'react';
import ReactDOM from 'react-dom';
import Main from './index/main.js';
import { LocaleProvider } from 'antd';
import { HashRouter, Route } from 'react-router-dom';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import "./font/iconfont.css";

import "./assets/index.css";
import "./assets/style.css";
import "./assets/theme.css";
import menuList from './index/menulist.js';
import common from './assets/common.js';

import "isomorphic-fetch";
import "fetch-detector";
import "fetch-ie8";
import promise from 'es6-promise';
promise.polyfill();

class Content extends React.Component {
  componentWillMount(){
    window.addEventListener('hashchange', function () {
      window.info = {};
      const key = window.location.hash.split("#")[1].split("?")[0];
      const keymenu = common.lookUpTree(menuList.list, 'sub', 'key', key);
      if(keymenu.length === 0){
        switch(window.info.adminRoles){
          case "":
            break;
          default:
            window.location.href = "#" + menuList.default;
            break;
        }
      }
    })
  }
  render(){
    return (
      <LocaleProvider locale={zhCN}>
        <HashRouter forceRefresh={true}>
          <Route path={ '/' } component={ Main }/>
        </HashRouter>
      </LocaleProvider>
    )
  }
}
ReactDOM.render(<Content />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js